import ReactDOM from 'react-dom';
import App from './App';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import './tailwind.css';

GoogleTagManager.initialize({
    customerJourney: 'Account pages',
    trackWithDataAttribute: true
});

ReactDOM.render(<App />, document.getElementById('root'));
